// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"638bc93e","239":"8cbfb096","453":"ff98790d","732":"8bef5f8d"}[chunkId] + ".chunk.js";
};